import React from 'react';
import { RoundedButton } from './RoundedButton';
import { FeedbackStepEnum } from '../enums/feedback-step';

export const FeedbackList = ({ pin, goNextStep, leaveReview, pointIsMissed}) => {
  return (
    <div className="Feedback-List">
    { pin.feedbackStep === FeedbackStepEnum.FOUND_INACCURACY && (
      <RoundedButton handleClick={goNextStep}>Нашёл неточность!</RoundedButton>) }
    { pin.feedbackStep === FeedbackStepEnum.FEEDBACK_LIST && (
      <>
        <div className="Feedback-List__header">Исправление данных</div>
        <RoundedButton handleClick={leaveReview}>Связаться с администрацией сайта</RoundedButton>
        <RoundedButton handleClick={pointIsMissed}>Точка отсутствует</RoundedButton>
      </>
    ) }
    { pin.feedbackStep === FeedbackStepEnum.THANK_YOU && (
      <>
        <div className="Feedback-List__header">Спасибо за участие</div>
        <div>Мы проверим полученную информацию</div>
      </>
    )}
    </div>
  )
}
